export default __webpack_public_path__ + "images/signinArt.72c632805aa71ad7f8d05db7e84d259a.svg";